import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../lib/axios.js";

/**
 * Hook to fetch a league's Team of the Week.
 * @param {string} leagueId - League ID
 * @param {number|null} round - Optional round; omit for the latest completed round
 * @returns {Object} - Query result with { season, round, availableRounds, team }
 */
export const useGetTeamOfTheWeek = (leagueId, round = null, options = {}) => {
  return useQuery({
    queryKey: ["totw", leagueId, round ?? "latest"],
    queryFn: async () => {
      const params = round != null ? { round } : {};
      const response = await axiosInstance.get(
        `/leagues/${encodeURIComponent(String(leagueId))}/totw`,
        { params }
      );
      return response.data;
    },
    enabled: !!leagueId && (options?.enabled ?? true),
    // Keep the previous round's payload on screen while the next one loads so
    // the round picker and availableRounds stay stable during switches.
    placeholderData: (previousData) => previousData,
    staleTime: 5 * 60 * 1000,
  });
};
